import * as React from 'react';
import { useBloomreachPageRoutes } from '@grandvisionhq/bloomreach';
import { Button } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';

const NoPrescription = ()=>{
    const { getLabel , getFormattedLabel  } = useIntl();
    const { routes  } = useBloomreachPageRoutes();
    var ref;
    const bookAppointmentRoute = (ref = routes['appointment-book']) !== null && ref !== void 0 ? ref : '';
    return /*#__PURE__*/ React.createElement("section", {
        className: "no-prescription"
    }, /*#__PURE__*/ React.createElement(Text, null, getFormattedLabel('account.noPrescription.message', {
        parseLink: true
    })), /*#__PURE__*/ React.createElement(Button, {
        caption: getLabel('stores.actions.selectStore'),
        href: bookAppointmentRoute.startsWith('/') ? bookAppointmentRoute : `/${bookAppointmentRoute}`
    }));
};

export { NoPrescription };
//# sourceMappingURL=NoPrescription.js.map
